/// <reference path="../../../../../typings/jquery.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/ModelsDokumentCheckConvertibleResponseApi.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/SchadenmeldungSchadenmeldungKostenReponseApi.d.ts"/>
import { AppUtils } from '../../../../../../shared/utils/index';
import { User } from '../../../../../../shared/models/api/User/User';
import { BasicApplicationRouter } from '../../../../../../shared/services/BasicApplicationRouter';
import { VesDamageValidationService } from '../../../../../../shared/services/VesDamageValidationService';
import { TarifartKostenApi } from "../../../../../../shared/models/generated/SchadenmeldungTarifartKostenApi";
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { BasicErrorService } from '../../../../../../shared/services/BasicErrorService';
import { UploadPersistenceService } from '../../../../../../shared/services/UploadPersistenceService';
import { UploadEvents, UploadViewService } from '../../../../../../shared/services/UploadViewService';
import { VesDamageUploadService } from '../../../../../../shared/services/VesDamageUploadService';
import { AppApiService } from '../../services/AppApiService';
import { DamageCostLimit } from "../../../../../../shared/models/view/DamageCostLimit.enum";
import { SchadenKostenApi } from "../../../../../../shared/models/generated/SchadenmeldungSchadenKostenApi";

export class DocumentsBillsOhcPageController implements StepController, UploadEvents {
	private readonly $ctx: JQuery;
	private readonly applicationRouter: BasicApplicationRouter<DamageDeclarationOhcAppDefinition>;
	private readonly user: User;
	private readonly options: DamageDeclarationOhcOptions;
	private readonly appViewService: AppViewService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly parent: AppController;
	private readonly loader: BasicLoader<DamageDeclarationOhcAppDefinition>;
	private appValidationService: VesDamageValidationService;
	private readonly uploadPersistenceService: UploadPersistenceService;
	private readonly uploadViewService: UploadViewService<DamageDeclarationOhcAppDefinition>;
	private readonly appErrorService: BasicErrorService<DamageDeclarationOhcAppDefinition>;
	private readonly uploadService: VesDamageUploadService;
	private readonly appApiService: AppApiService;
	private readonly loaderIdStartFileUpload = "DocumentsBillsOhcPageController startFileUploadListener";
	private readonly loaderIdCheckFiles = "DocumentsBillsOhcPageController checkFilesAndProceed";

	constructor(parent: AppController, options: DamageDeclarationOhcOptions, loader: BasicLoader<DamageDeclarationOhcAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.user = user;
		this.$ctx = $(options.$ctx);

		this.applicationRouter = new BasicApplicationRouter(options);
		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(parent, options, loader);
		this.appErrorService = new BasicErrorService(options);
		this.appApiService = new AppApiService(options, user);

		this.uploadService = new VesDamageUploadService(options);
		this.uploadPersistenceService = new UploadPersistenceService(options);
		this.uploadViewService = new UploadViewService(options);
	}

	public start(): void {
		if (this.checkPreconditions()) {
			const viewConfig = {
				data: this.getViewOptions(),
				templateurl: this.options.app.currenttemplate.templateurl,
				campaignurls: this.options.app.campaignurls,
				parent: this,
				$ctx: this.$ctx,
				options: this.options,
				callback: this.afterRenderApp
			};
			this.appViewService.render(viewConfig);
		} else {
			T.Utils.Helper.routeToUrl(this.options.app.entryredirecturl);
		}
	}

	private checkPreconditions(): boolean {
		const damageModel = this.appPersistenceService.getDamageOhcFormModel();
		return $('body').hasClass(this.options.app.pageEditorClass) || (damageModel !== undefined);
	}


	/**
	 * returns view options for the page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): { [key: string]: any } {
		const formModel = this.appPersistenceService.getApplicationModel();
		const uploadModel = this.uploadPersistenceService.getUploadModelFromStore();

		return {
			User: this.user,
			DamageModel: formModel.DamageFormModel,
			DocumentsBillModel: formModel.DocumentsBillsFormModel,
			UploadModel: uploadModel,
			CostLimit: formModel.CostLimit,
			DescriptionLimit: this.options.app.validatorRules.rules.KostenAngaben['maxlength'],
			nexturl: this.options.app.nexturl || '',
			prevurl: this.options.app.prevurl || '',
		};
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			this.appValidationService = new VesDamageValidationService({ options: this.options }, this.appViewService.getForm(), false);
			this.parent.afterRenderApp();

			this.appViewService.addDocumentBillsListeners(this.sumChangeListener.bind(this), this.costTypeChangeListener.bind(this), this.viewChangeListener.bind(this), this.submitListener.bind(this));
			this.uploadViewService.addUploadEventListener(this);

			const formModel = this.appViewService.getFormModelFromDocumentsBillsDataView();
			this.appViewService.updateSummaryCostsToView(formModel.KostenSummen);
			this.appViewService.toggleCommentTextArea(formModel.Kostenart ? true : false);

			this.checkCostLimitAndUpdateView();
			this.appViewService.restoreSectionBackground();
			AppUtils.View.stopLoader("damagedeclarationohc initApplication");
		});
	}
	public addFileUploadListener(_event: JQuery.TriggeredEvent): void {
		this.appValidationService.updateValidationMessages();
	}

	public sumChangeListener(_event: JQuery.TriggeredEvent): void {
		this.checkCostLimitAndUpdateView();
	}

	private checkCostLimitAndUpdateView(): void {
		const formModel = this.appViewService.getFormModelFromDocumentsBillsDataView();
		if (Object.keys(formModel.KostenSummen).length > 0) {
			this.appApiService.getSchadenkosten(TarifartKostenApi.Aks, formModel.KostenSummen, this.handleGetSchadenkostenReponse.bind(this), this.handleErrorRespone.bind(this));
		} else {
			this.updateCostLimit(DamageCostLimit.Ok);
		}
	}

	public handleErrorRespone(): void {
		T.Utils.Helper.routeToUrl(this.options.app.errorpageurl);
	}

	public handleGetSchadenkostenReponse(data: ApiResponse<SchadenmeldungKostenReponseApi>): void {
		let costLimitType: DamageCostLimit;
		switch (data.Data.Kosten) {
			case SchadenKostenApi.Ok:
				costLimitType = DamageCostLimit.Ok;
				break;
			case SchadenKostenApi.MehrAlsKostengrenzeEins:
				costLimitType = DamageCostLimit.MehrAlsKostengrenzeEins;
				break;
			case SchadenKostenApi.MehrAlsKostengrenzeZwei:
				costLimitType = DamageCostLimit.MehrAlsKostengrenzeZwei;
				break;
			default:
				costLimitType = DamageCostLimit.MehrAlsKostengrenzeZwei;
				break;
		}
		this.updateCostLimit(costLimitType);
	}

	private updateCostLimit(costLimitStatus: DamageCostLimit): void {
		const formModel = this.appPersistenceService.getApplicationModel();
		formModel.CostLimit = costLimitStatus;
		this.appPersistenceService.setApplicationModel(formModel);
		this.appViewService.hideOrShowProofDepatureSection(formModel.CostLimit);
	}

	public costTypeChangeListener(event: JQuery.TriggeredEvent): void {
		const $uploadData = this.appViewService.getUploadCostTypeDataFromView($(event.currentTarget as HTMLElement));
		if ($uploadData.length > 0) {
			event.preventDefault();
			this.appErrorService.errorDialog(this.options.app.messagedeselctioncosttypedata, true);
		}
	}

	public startFileUploadListener(event: JQuery.TriggeredEvent): void {
		const $uploadContainer = this.uploadViewService.getTriggerdUploadContainerFromView($(event.currentTarget));
		const $onlySelectedFiles = this.uploadViewService.getOnlySelectedFilesFromView($uploadContainer);

		this.appValidationService.resetErrorMessages($uploadContainer);
		if ($onlySelectedFiles.length > 0) {
			AppUtils.View.startLoader(this.loaderIdStartFileUpload, 60000);

			const appModel = this.appPersistenceService.getApplicationModel();
			const $uploadElements = this.uploadViewService.getUploadedElementsFromView($uploadContainer);
			this.uploadService.uploadFiles($uploadElements, appModel.Vorgangsnummer, this.handleUploadResponse.bind(this), this.handleUpdloadValidationError.bind(this));
		}
	}



	private triggerUploadValidations(uploadContainer: JQuery): void {
		const inputCostIds = this.appViewService.getInputFileIds(uploadContainer);
		this.appValidationService.triggerValidation(inputCostIds);
	}

	public deleteFileUploadListener(event: JQuery.TriggeredEvent): void {
		const $elm = $(event.currentTarget);
		this.uploadService.deleteFile($elm.attr('id'));
		this.appPersistenceService.setDocumentsBillsOhcFormModel(this.appViewService.getFormModelFromDocumentsBillsDataView());

		this.appValidationService.setServerValidationFlags(true, this.appViewService.getInputFileIds($elm));
		this.appValidationService.resetErrorMessages($elm);
	}

	private handleUploadResponse(data: ApiResponse<string>, elemId: string): void {
		this.uploadService.updateFileView(elemId, data);
		const formModel = this.appViewService.getFormModelFromDocumentsBillsDataView();
		this.appPersistenceService.setDocumentsBillsOhcFormModel(formModel);
		this.appViewService.updateSummaryCostsToView(formModel.KostenSummen);
		AppUtils.View.stopLoader(this.loaderIdStartFileUpload);
	}

	private handleUpdloadValidationError(element: JQuery): void {
		this.triggerUploadValidations(this.uploadViewService.getTriggerdUploadContainerFromView(element));
		AppUtils.View.stopLoader(this.loaderIdStartFileUpload);
	}

	/**
	* Stores changes the DamageOhcFormModel on page changes
	*/
	private viewChangeListener(): void {
		AppUtils.Helper.scheduleTask(() => {
			const formModel = this.appViewService.getFormModelFromDocumentsBillsDataView();
			this.appPersistenceService.setDocumentsBillsOhcFormModel(formModel);
			this.appViewService.updateSummaryCostsToView(formModel.KostenSummen);
			this.appViewService.toggleCommentTextArea(formModel.Kostenart ? true : false);
			this.appViewService.restoreSectionBackground();
		}, 'user-visible');
	}

	/**
	 * Shows the documentsBillsPage when this page is valid
	 */
	private submitListener(event: JQuery.Event): void {
		event.preventDefault();
		if (this.appValidationService.isValid()) {
			this.checkFilesAndProceed();
		}
	}

	/**
* Performs File check. If successful continues to the next page, if not, fielderrors are shown.
*/
	private checkFilesAndProceed(): void {
		const model = this.appPersistenceService.getApplicationModel();
		const fileIds = this.appViewService.getFileIdsFromView();
		AppUtils.View.startLoader(this.loaderIdCheckFiles);

		if (fileIds.length > 0) {
			this.appApiService.checkConvertible(model.Vorgangsnummer, fileIds, this.handleCheckConvertibleSuccess.bind(this), this.handleCheckConvertibleError.bind(this));
		} else {
			this.handleCheckConvertibleSuccess();
		}
	}

	private handleCheckConvertibleSuccess(): void {
		this.viewChangeListener();
		this.applicationRouter.next();
		AppUtils.View.stopLoader(this.loaderIdCheckFiles);
	}

	private handleCheckConvertibleError(jqxhr: JQueryXHR): void {
		if (jqxhr.responseJSON) {
			const response = jqxhr.responseJSON as ApiResponse<DokumentCheckConvertibleResponseApi>;
			let inputScrollTo: JQuery;
			const errorIds: string[] = [];
			response.Data.Ergebnisse.forEach((item => {
				if (item.Ok === false) {
					const input = this.appViewService.getInputFieldOnFileGuid(item.FileId);
					if (input) {
						inputScrollTo = input;
						const id = input.attr('id');
						this.appValidationService.setServerValidationFlag(false, id);
						errorIds.push(id);
					}
				}
			}));
			this.appValidationService.triggerValidationAndScrollToError(errorIds, $(inputScrollTo));
			AppUtils.View.stopLoader(this.loaderIdCheckFiles);
		} else {
			T.Utils.Helper.routeToUrl(this.options.app.errorpageurl);
		}
	}
}
